/* eslint-disable react/no-unused-prop-types */
import React from "react";
import PropTypes from "prop-types";

const Pane = ({ children }) => <>{children}</>;

Pane.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  default: PropTypes.bool,
};

Pane.defaultProps = {
  default: false,
};

export default Pane;
